import {
  login,
  npsw,
  updateProjectPwd,
  getUserList,
  add,
  change,
  del,
  serch,
  changeAvatar,
  getRoleList,
  changeMenu,
  getMenuList,
  addMenu,
  delMenu,
  getRoleMenu,
  changeRole,
} from "@/api/user";
import router from "@/router/index";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    isLogin: localStorage.getItem("VUE_ADMIN_ISLOGIN") || false,
    token: localStorage.getItem(process.env.VUE_APP_TOKEN_NAME) || "",
    // 用户的菜单列表数据
    menuList:
      JSON.parse(localStorage.getItem(process.env.VUE_APP_MENU_LIST)) || [],
    menuUrls:
      JSON.parse(localStorage.getItem(process.env.VUE_APP_MENU_URLS)) || [],
    // 是否动态添加路由
    isDynamicAddedRoute: false,
    userInfo:
      JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO)) || {},
    // 分页
    page: {
      // 每页条数
      pageSize: parseInt(localStorage.getItem("pageSize")) || 10,
      // 当前页码
      pageNum: 1,
      // 总条数
      total: 0,
    },
    userTableData: {
      tabeHeader: [
        {
          label: "用户名",
          prop: "username",
          width: "",
        },
        {
          label: "昵称",
          prop: "nickname",
          width: "",
        },
        {
          label: "手机",
          prop: "phone",
          width: "",
        },
        {
          label: "邮箱",
          prop: "email",
          width: "",
        },
        {
          label: "角色",
          prop: "role_name",
          width: "",
        },
        {
          label: "状态",
          prop: "is_open",
          width: "",
        },
        {
          label: "创建人",
          prop: "created_by",
          width: "",
        },
        {
          label: "创建时间",
          prop: "created_time",
          width: "",
        },

        {
          label: "备注",
          prop: "info",
          width: "",
        },
      ],
      userList: [],
    },
    roleTableData: {
      tabeHeader: [
        {
          label: "角色名称",
          prop: "ROLE_NAME",
          width: "",
        },
        {
          label: "角色值",
          prop: "ROLE_ID",
          width: "",
        },
        {
          label: "更新时间",
          prop: "UPDATED_TIME",
          width: "",
        },
        {
          label: "备注",
          prop: "ROLE_INFO",
          width: "",
        },
      ],
      roleList: [],
      page: {
        // 每页条数
        pageSize: 10,
        // 当前页码
        pageNum: 1,
        // 总条数
        total: 0,
      },
    },
    menuTableData: {
      tabeHeader: [
        {
          label: "菜单名称",
          prop: "MENU_NAME",
          width: "",
        },
        {
          label: "菜单图标",
          prop: "MENU_ICON",
          width: "",
        },
        {
          label: "类型",
          prop: "MENU_TYPE",
          width: "",
        },
        {
          label: "路由路径",
          prop: "MENU_PATH",
          width: "",
        },
        {
          label: "组件路径",
          prop: "COMPONET",
          width: "",
        },
        {
          label: "状态",
          prop: "DEL_FLAG",
          width: "",
        },
        {
          label: "排序",
          prop: "ORDER_NUM",
          width: "",
        },
      ],
      menuList: [],
    },
  },
  mutations: {
    // 设置用户信息
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    // 设置token
    updateToken(state, token) {
      state.token = token;
      localStorage.setItem(process.env.VUE_APP_TOKEN_NAME, token);
    },
    // 设置用户信息
    updateUserInfo(state, userInfoObj) {
      // 检查 avatar 是否存在且是 {type: 'Buffer', data: [...]}
      if (
        userInfoObj.avatar &&
        userInfoObj.avatar.type === "Buffer" &&
        Array.isArray(userInfoObj.avatar.data)
      ) {
        const uint8Array = new Uint8Array(userInfoObj.avatar.data);
        const blob = new Blob([uint8Array], { type: "image/png" }); // 你可以根据实际图像类型修改 MIME 类型
        const reader = new FileReader();
        reader.onloadend = () => {
          // reader.result 是一个 Base64 编码的字符串
          userInfoObj.avatar = reader.result;
          // 更新 state 和 localStorage
          state.userInfo = userInfoObj;
          localStorage.setItem(
            process.env.VUE_APP_USER_INFO,
            JSON.stringify(userInfoObj)
          );
        };

        reader.readAsDataURL(blob);
      } else {
        // 如果 avatar 不是 {type: 'Buffer', data: [...]}, 直接更新 state 和 localStorage
        state.userInfo = userInfoObj;
        localStorage.setItem(
          process.env.VUE_APP_USER_INFO,
          JSON.stringify(userInfoObj)
        );
      }
    },

    // 设置用户登录状态
    setLoginState(state, flag) {
      state.isLogin = flag;
      localStorage.setItem("VUE_ADMIN_ISLOGIN", flag);
    },
    // 置用户的菜单列表数据
    setMenuList(state, menuList) {
      state.menuList = menuList;
      state.menuVersion = (state.menuVersion || 0) + 1;
      localStorage.setItem(
        process.env.VUE_APP_MENU_LIST,
        JSON.stringify(menuList)
      );
    },
    // 置用户的菜单列表数据
    setMenuUrls(state, menuUrls) {
      state.menuUrls = menuUrls;
      localStorage.setItem(
        process.env.VUE_APP_MENU_URLS,
        JSON.stringify(menuUrls)
      );
    },
    // 处理退出登录
    logout(state) {
      state.isLogin = false;
      localStorage.removeItem("VUE_ADMIN_ISLOGIN");
      state.token = "";
      localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
      state.menuList = [];
      localStorage.removeItem(process.env.VUE_APP_MENU_LIST);
      state.userInfo = {};
      localStorage.removeItem(process.env.VUE_APP_USER_INFO);
      // 清空localStorage
      localStorage.clear();

      router.push("/login");
    },
    // 设置是否动态添加路由
    setDynamicAddedRoute(state, flag) {
      state.isDynamicAddedRoute = flag;
    },
    // 设置用户总数据
    setUserTotal(state, res) {
      state.page.total = res.data.total;
      state.userTableData.userList = res.data.list;
    },
    // 设置角色数据
    setRoleList(state, res) {
      state.roleTableData.page.total = res.data.total;
      const roleData = res.data.list;
      // 时间格式化
      roleData.forEach((item) => {
        if (item.UPDATED_TIME !== null)
          item.UPDATED_TIME = moment(item.UPDATED_TIME).format(
            "YYYY-MM-DD HH:mm:ss"
          );
      });
      // 兼容新旧系统：超级管理员不显示在角色列表中供分配
      // 新系统用 role_key === 'sys_admin'，旧系统用 role_id === '1001'
      const isSysAdmin = state.userInfo.is_sys_admin === true ||
        state.userInfo.role_id === '1001' ||
        state.userInfo.roles?.some(r => r.role_key === 'sys_admin');

      if (!isSysAdmin) {
        const filteredRoleData = roleData.filter((item) => {
          const roleId = item.ROLE_ID || item.id || item.role_id;
          return roleId !== '1001';
        });
        state.roleTableData.roleList = filteredRoleData;
      } else {
        state.roleTableData.roleList = roleData;
      }
    },
  },
  actions: {
    //异步业务
    // 登录
    loginAction({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        login(data)
          .then((res) => {
            // 统一权限系统返回结构：res.data.userinfo
            if (!res || !res.data) {
              reject(new Error("登录响应数据异常"));
              return;
            }

            commit("updateToken", res.data.token);
            commit("updateUserInfo", res.data.userinfo);
            commit("setMenuList", res.data.userinfo.menus);
            commit("setMenuUrls", res.data.userinfo.menu_urls || []);
            commit("setLoginState", true);
            // 处理权限路由
            dispatch("loadAsyncRoute");
            resolve(res.message);
          })
          .catch((err) => {
            // 提取具体的业务错误信息，交由登录页展示，此处不弹窗
            let errorMsg = "登录失败，请稍后重试";

            if (err?.response) {
              // HTTP 4xx/5xx：从响应体中提取后端返回的错误消息
              errorMsg =
                err.response.data?.data?.message ||
                err.response.data?.message ||
                errorMsg;
            } else if (err?.code === "ECONNABORTED") {
              errorMsg = "请求超时，请检查网络连接";
            } else if (err?.message?.includes("Network Error")) {
              errorMsg = "网络错误，请检查网络连接";
            } else if (err?.message) {
              errorMsg = err.message;
            }

            reject(new Error(errorMsg));
          });
      });
    },

    // 处理权限路由，动态添加路由
    async loadAsyncRoute({ state, commit }) {
      // 保存系统中所有的权限路由
      const allRoutes = [];
      // 1、递归获取router/modules目录下的js文件  true 表示是否递归
      const routeFiles = require.context("@/router/modules", true, /\.js$/);
      routeFiles.keys().forEach((key) => {
        const routes = require("@/router/modules" + key.split(".")[1]);
        // 根据文件名标记来源平台
        const source = key.includes("mecs") ? "mecs" : key.includes("des_mw") ? "des_mw" : key.includes("des_tes") ? "des_tes" : "";
        routes.default.forEach((r) => {
          allRoutes.push({ ...r, _source: r._source || source });
        });
      });

      // 获取当前登录用户的权限路由路径列表
      const backRoutes = state.menuUrls;

      // 2.比对筛选出权限路由
      const asyncRoutes = allRoutes.filter((item) => {
        // 相对路径（系统管理等嵌套路由）：检查数据库中是否有包含该相对路径的完整路径
        if (!item.path.startsWith("/")) {
          return backRoutes.some((backPath) => backPath.includes(item.path));
        }
        // 绝对路径：精确匹配
        return backRoutes.includes(item.path);
      });

      // 3.将权限路由添加到对应的 Layout 中
      asyncRoutes.forEach((route) => {
        const src = route._source || "";
        // 相对路径（系统管理等嵌套路由）：根据来源平台添加到对应 system layout
        if (!route.path.startsWith("/")) {
          if (src === "mecs") {
            router.addRoute("layout_mecs_system", route);
          } else if (src === "des_mw") {
            router.addRoute("layout_mw_system", route);
          } else if (src === "des_tes") {
            router.addRoute("layout_tes_system", route);
          }
        } else if (route.path.startsWith("/system")) {
          // 公共系统管理菜单，注册到所有平台 system layout，路径替换为对应平台
          router.addRoute("layout_mecs_system", { ...route, path: route.path.replace("/system", "/mecs/system") });
          router.addRoute("layout_mw_system", { ...route, path: route.path.replace("/system", "/des_mw/system") });
          router.addRoute("layout_tes_system", { ...route, path: route.path.replace("/system", "/des_tes/system") });
        } else if (route.path.includes("/mecs/system")) {
          router.addRoute("layout_mecs_system", route);
        } else if (route.path.includes("/des_mw/system")) {
          router.addRoute("layout_mw_system", route);
        } else if (route.path.includes("/des_tes/system")) {
          router.addRoute("layout_tes_system", route);
        } else if (route.path.includes("des_mw")) {
          router.addRoute("layout_mw", route);
        } else if (route.path.includes("/mecs")) {
          router.addRoute("layout_mecs", route);
        } else if (route.path.includes("des_tes")) {
          router.addRoute("layout_tes", route);
        }
      });

      // 用 is_sys_admin 代替硬编码 role_id
      const isSysAdmin = state.userInfo.is_sys_admin === true;
      const projects = state.userInfo.projects || [];

      // 超级管理员：加载系统管理后台路由
      if (isSysAdmin) {
        const adminRoutes = require("@/router/modules/admin_router.js").default;
        adminRoutes.forEach((route) => {
          router.addRoute("layout_admin", route);
        });
      }

      // 添加根路径路由，由导航守卫处理重定向
      if (!router.hasRoute("index")) {
        router.addRoute({
          path: "/",
          name: "index",
          component: () => import("@/layout/mecs.vue"),
        });
      }

      // 标识该用户已经加载过权限路由
      commit("setDynamicAddedRoute", true);
    },

    // 处理更新用户（供 mecs_views/project/usermanage.vue 使用）
    async updateUser({ commit }, data) {
      const userId = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO)).id;
      const project_id = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO)).project_id;
      data.updated_by = userId;
      data.project_id = project_id;
      if (!data.user_id && data.id) data.user_id = data.id;
      if (data.is_open !== undefined) data.is_open = data.is_open === true ? 1 : 0;
      return await change(data);
    },

    // 处理更新用户（供 mw_views/project/usermanage.vue 使用）
    async changeAction({ commit }, data) {
      const userId = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO)).id;
      const project_id = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO)).project_id;
      data.updated_by = userId;
      data.project_id = project_id;
      if (!data.user_id && data.id) data.user_id = data.id;
      return await change(data);
    },

    // 添加用户
    async addUser({ commit }, data) {
      const userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO));
      const created_by = userInfo.id;
      const project_id = userInfo.project_id ||
        (userInfo.projects && userInfo.projects.length > 0 ? userInfo.projects[0].project_id : null);
      data.created_by = created_by;
      if (project_id) data.project_id = project_id;
      if (data.is_open === undefined) data.is_open = 1;
      return await add(data);
    },

    // 获取所有用户总数和列表
    async UserTotal({ commit }, data) {
      // 获取用户id
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      data.user_id = userId;
      const res = await getUserList(data);
      commit("setUserTotal", res);
      return res;
    },
    // 获取所有角色
    async getRoleList({ commit }, data) {
      // 获取用户id
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      data.user_id = userId;
      const res = await getRoleList(data);
      commit("setRoleList", res);
      return res;
    },

    // 查询用户
    async serchUser({ commit }, data) {
      // 获取用户id
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      data.user_id = userId;
      const res = await serch(data);
      commit("setUserTotal", res);
      return res;
    },

    // 删除用户（供 mw_views/project/usermanage.vue 使用）
    async delAction({ commit }, data) {
      if (!data.user_id && data.id) data.user_id = data.id;
      return await del(data);
    },

    // 删除用户（供 mecs_views/project/usermanage.vue 使用）
    async deleteUser({ commit }, data) {
      if (!data.user_id && data.id) data.user_id = data.id;
      return await del(data);
    },

    // 处理修改密码（根据用户角色自动选择接口）
    async nPswAction({ commit }, data) {
      const userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO));
      const userId = userInfo.id;
      if (userInfo.is_sys_admin) {
        return await npsw({ userId, oldPassword: data.oldPswd, newPassword: data.newPswd });
      }
      return await updateProjectPwd({
        user_id: userId,
        oldPswd: data.oldPswd,
        newPswd: data.newPswd,
        newPswdCheck: data.newPswdCheck,
      });
    },

    // 修改头像
    async changeAvatar({ commit, dispatch }, data) {
      const res = await changeAvatar({ avatar: data });
      // 上传成功后直接更新 store + localStorage 中的头像，无需重新登录
      const userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO));
      userInfo.avatar = data;
      localStorage.setItem(process.env.VUE_APP_USER_INFO, JSON.stringify(userInfo));
      commit('setUserInfo', userInfo);
      return res;
    },

    // 获取用户菜单
    async getMenuList({ commit }) {
      const userId = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO)).id;
      const project_type = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO)).project_type;
      const res = await getMenuList({ user_id: userId, project_type });
      if (res && (res.code === 0 || res.code === 200)) {
        commit("setMenuList", res.data.menu);
      }
      return res;
    },

    // 修改用户菜单
    async changeMenu({ commit }, data) {
      const userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO));
      if (!data.user_id) data.user_id = userInfo.id;
      if (!data.project_type) data.project_type = userInfo.project_type;
      return await changeMenu(data);
    },

    // 添加用户菜单
    async addMenu({ commit }, data) {
      const userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO));
      if (!data.user_id) data.user_id = userInfo.id;
      if (!data.project_type) data.project_type = userInfo.project_type;
      return await addMenu(data);
    },

    // 删除用户菜单
    async delMenu({ commit }, data) {
      const userId = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO)).id;
      if (!data.user_id) data.user_id = userId;
      return await delMenu(data);
    },

    // 通过 role_id 和 project_type 获取用户权限列表
    async getRoleMenu({ commit }, data) {
      return await getRoleMenu(data);
    },

    // 修改用户权限信息
    async changeRole({ commit }, data) {
      const userId = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO)).id;
      data.user_id = userId;
      return await changeRole(data);
    },
  },
};
